import axios from '@/plugins/axios';

const USER = '/user';
const PERMISSION = '/permission';

export async function getUserInfo() {
  try {
    const { data } = await axios.get(`${USER}/user-info`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function uploadStampImage(payload) {
  try {
    const { data } = await axios.post(`${USER}/stamp-image`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkValidateBasicInfo(payload) {
  try {
    const { data } = await axios.post(`${USER}/edit/validate`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function updateBasicInfo(payload) {
  try {
    const { data } = await axios.post(`${USER}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getUserPermission() {
  try {
    const { data } = await axios.get(`${PERMISSION}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getDestinationInfo() {
  try {
    const { data } = await axios.get(`${USER}/destination-info`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function checkValidateEditDestinationInfo(payload) {
  try {
    const { data } = await axios.post(`${USER}/check-validate-destination`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function editDestinationInfo(id, payload) {
  try {
    const { data } = await axios.put(`${USER}/destination-info/${id}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function sendDestinationVerifyMail(id) {
  try {
    const { data } = await axios.post(`${USER}/destination-info/${id}/verify`);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function verifyDestinationEmail(token) {
  try {
    const { data } = await axios.get(`${USER}/destination-info/verify/${token}`);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function verifyBasicInfoEmail(token) {
  try {
    const { data } = await axios.get(`${USER}/user-info/verify/${token}`);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function getFileStamp(id, type, sorting) {
  try {
    return await axios.get(`${USER}/user-account/${id}/${type}${sorting ? '/' + sorting : ''}`, {
      responseType: "blob"
    });
  } catch (error) {
    return { error };
  }
}

export async function getFile(id, type, sorting, fileType) {
  try {
    return await axios.get(`${USER}/user-account/${id}/${type}/${sorting}${fileType ? '/' + fileType : ''}`, {
      responseType: fileType === 'pdf' ? 'arraybuffer' : 'blob'
    });
  } catch (error) {
    return { error };
  }
}
